import { Box, FileSearch, PackageCheck, PenTool } from 'lucide-react'

export const workflows = [
  {
    id: 'create',
    title: 'Criar modelo do zero',
    description: 'Comece um projeto paramétrico a partir de uma necessidade.',
    icon: Box,
    action: 'new',
    preset: {
      useCase: 'Peça funcional personalizada',
      tags: ['novo-modelo'],
    },
  },
  {
    id: 'customize',
    title: 'Customizar existente',
    description: 'Registre medidas, alterações e uma nova versão do modelo.',
    icon: PenTool,
    action: 'customize',
  },
  {
    id: 'bambu',
    title: 'Preparar para Bambu',
    description: 'Valide orientação, suporte e gere o projeto de fatiamento.',
    icon: PackageCheck,
    action: 'copy',
    prompt: (project) => `Abra o projeto ${project?.id || '[selecione um modelo]'} no Ateliê 3D. Leia a skill bambu-3mf-export e prepare os arquivos verificados para Bambu Lab A1, incluindo orientação, suportes, perfil e validação de fatiamento. Registre a exportação e as decisões no histórico do projeto.`,
  },
  {
    id: 'analyze',
    title: 'Analisar arquivo',
    description: 'Importe STL, STEP ou 3MF e verifique malha e impressão.',
    icon: FileSearch,
    action: 'new',
    preset: {
      title: 'Análise de arquivo 3D',
      description: 'Analisar o arquivo anexado, verificar integridade, medidas, espessuras, orientação e possíveis problemas de impressão.',
      useCase: 'Análise e preparação de arquivo existente',
      tags: ['analise', 'arquivo-existente'],
    },
  },
]

export const skillShortcuts = [
  {
    title: 'Modelar uma peça',
    skill: '3d-print-modeling',
    description: 'Modelagem paramétrica, render, inspeção e regras FDM.',
    prompt: 'Use a skill 3d-print-modeling. Abra meu pedido mais recente no Ateliê 3D, confirme as medidas críticas e modele a peça de forma paramétrica. Execute os gates e registre os arquivos e a customização no projeto.',
  },
  {
    title: 'Exportar para Bambu',
    skill: 'bambu-3mf-export',
    description: 'Cria um projeto 3MF pronto para o Bambu Studio.',
    prompt: 'Use a skill bambu-3mf-export no modelo selecionado do Ateliê 3D. Gere o 3MF com perfil adequado, valide o fatiamento e registre a exportação no histórico.',
  },
  {
    title: 'Revisar antes de imprimir',
    skill: '3d-print-modeling / R7',
    description: 'Checa malha, folgas, montagem, renders e fatiamento.',
    prompt: 'Revise o modelo selecionado no Ateliê 3D antes da impressão. Aplique as regras R1–R8 de docs/DESIGN-RULES.md, execute os gates disponíveis, leia os renders e liste claramente o que foi validado e o que ainda exige impressão de teste.',
  },
  {
    title: 'Alterar um modelo',
    skill: '3d-print-modeling',
    description: 'Preserva a fonte paramétrica e registra uma nova versão.',
    prompt: 'Use a skill 3d-print-modeling para customizar o modelo selecionado no Ateliê 3D. Preserve interfaces já impressas, altere os parâmetros na fonte, regenere os artefatos, compare os renders e registre a nova versão e a justificativa no histórico.',
  },
]
